module.exports = __webpack_public_path__ + "static/media/Avatars_Female-05.c8e36748.png";